import { getFontPlatform } from 'utils';
import config from 'configs';

export const initFonts = () => {
  const platform = getFontPlatform();

  // For partner which want self fonts we need to upload local in assets/fonts/[fontName]/stylesheet.css then import it in assets/fonts/special/style.css

  // We don't use webFontLoader with Google font because some fonts has not found in google font
  const font = config.content?.fonts?.[platform] || config.content?.fonts?.default || 'Poppins';

  if (document.documentElement) {
    document.documentElement.style.fontFamily = font;
    document.documentElement.style.setProperty('--font', font);
  }
};
